'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty$1 = require('@babel/runtime/helpers/defineProperty');
var niConstants = require('ni-constants');
var React = require('react');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var cloneDeep = require('lodash.clonedeep');
var get = require('lodash.get');
var pick = require('lodash.pick');
var md5 = require('md5');
var get$1 = require('lodash/get');
var uuid = require('uuid');
var _typeof = require('@babel/runtime/helpers/typeof');
var snakeCase = require('lodash/snakeCase');
var lodash = require('lodash');
var pick$1 = require('lodash/pick');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var cloneDeep__default = /*#__PURE__*/_interopDefault(cloneDeep);
var get__default = /*#__PURE__*/_interopDefault(get);
var pick__default = /*#__PURE__*/_interopDefault(pick);
var md5__default = /*#__PURE__*/_interopDefault(md5);
var get__default$1 = /*#__PURE__*/_interopDefault(get$1);
var snakeCase__default = /*#__PURE__*/_interopDefault(snakeCase);
var pick__default$1 = /*#__PURE__*/_interopDefault(pick$1);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function buildReportChart(reportBuilderObject) {
  var _productList$products;

  var chart = reportBuilderObject.chart,
      products = reportBuilderObject.products,
      manipulators = reportBuilderObject.manipulators,
      siteId = reportBuilderObject.siteId,
      textOnCTA = reportBuilderObject.textOnCTA,
      numberOfVisibleProducts = reportBuilderObject.numberOfVisibleProducts;
  var comp_iid = chart.comp_iid,
      _chart$filterSettings = chart.filterSettings,
      filterSettings = _chart$filterSettings === void 0 ? {} : _chart$filterSettings,
      _chart$appliedVendors = chart.appliedVendors,
      appliedVendors = _chart$appliedVendors === void 0 ? [] : _chart$appliedVendors,
      productList = chart.productList;
  var PROPS_TO_REPORT = ['id', 'varId', 'ver', 'entityType', 'manipulators'];
  var filterSettingsReportData = cloneDeep__default["default"](filterSettings);
  var filters = get__default["default"](filterSettingsReportData, 'filters', []);
  filterSettingsReportData.filters = [].concat(_toConsumableArray(filters), _toConsumableArray(appliedVendors));
  var productListReportData = pick__default["default"](productList, PROPS_TO_REPORT);
  var chartReportData = pick__default["default"](chart, PROPS_TO_REPORT);
  var reportProducts = products.map(function (product) {
    return pick__default["default"](product, [].concat(PROPS_TO_REPORT, ['position']));
  });
  var md5ReportingData = [productListReportData, chartReportData];
  var productsWithCustomFeatures = products.map(function (product) {
    var _product$featuresToRe;

    return _objectSpread2(_objectSpread2({}, product), {}, {
      productFeatures: (_product$featuresToRe = product.featuresToReport) !== null && _product$featuresToRe !== void 0 ? _product$featuresToRe : []
    });
  });
  var instanceId = md5__default["default"](JSON.stringify(md5ReportingData));
  var reportProps = {
    siteId: siteId,
    textOnCTA: textOnCTA,
    products: productsWithCustomFeatures,
    instanceId: instanceId,
    comp_iid: comp_iid,
    filterSettings: filterSettingsReportData
  };
  var productListSize = products.length;
  var showMorePosition = getShowMorePositionForReporting(numberOfVisibleProducts, productListSize);
  return _objectSpread2(_objectSpread2({}, chart), {}, {
    manipulators: manipulators,
    products: reportProducts,
    productListReportData: productListReportData,
    reportProps: reportProps,
    productListHeader: buildProductListHeader(productList === null || productList === void 0 ? void 0 : (_productList$products = productList.products) === null || _productList$products === void 0 ? void 0 : _productList$products.length, productListReportData, showMorePosition)
  });
}

function getShowMorePositionForReporting(numberOfVisibleProducts, productListSize) {
  if (!numberOfVisibleProducts || numberOfVisibleProducts >= productListSize) {
    return null;
  }

  return numberOfVisibleProducts;
}

function buildProductListHeader(productListSize, productListReportData, showMorePosition) {
  if (!productListSize) {
    return;
  }

  return {
    product_list_id: productListReportData.id,
    product_list_var_id: productListReportData.varId,
    product_list_var_version: productListReportData.ver,
    product_list_size: productListSize,
    product_list_show_more_position: showMorePosition
  };
}

function _isValidString(value) {
  return typeof value === 'string' && value.length > 0;
}

function extractProductFeaturesFromProduct(_ref) {
  var productFeatures = _ref.productFeatures,
      product = _ref.product;

  if (!productFeatures || _typeof(productFeatures) !== 'object') {
    return [];
  } // eslint-disable-next-line unicorn/no-array-reduce


  return Object.keys(productFeatures).reduce(function (acc, featureName) {
    var productFeature = product === null || product === void 0 ? void 0 : product[featureName];

    if (!productFeature) {
      return acc;
    }

    var id = productFeature.id,
        _productFeature$value = productFeature.value,
        value = _productFeature$value === void 0 ? {} : _productFeature$value;
    var featureValue = value.value;

    if (!featureValue || !id) {
      return acc;
    }

    var name = snakeCase__default["default"](featureName);
    acc.push({
      id: id,
      name: name,
      value: featureValue
    });
    return acc;
  }, []);
}
function addOrReplaceParameterValueInUrl(opts) {
  var url = opts.url,
      parameterName = opts.parameterName,
      newValue = opts.newValue;

  if (!_isValidString(url) || !_isValidString(parameterName) || !_isValidString(newValue)) {
    console.warn("Error: addOrReplaceParameterValueInUrl received unexpected values: url ".concat(url, ", parameterName ").concat(parameterName, ", newValue ").concat(newValue, "."));
    return url;
  } // if parameterName is not in the url, add it with the newValue.


  if (!url.includes(parameterName)) {
    return "".concat(url + (url.indexOf('?') > 0 ? '&' : '?') + parameterName, "=").concat(newValue);
  } // if parameterName is in the url, replace it's value.
  // eslint-disable-next-line no-useless-escape


  var regExPattern = new RegExp("(".concat(parameterName, "=)[^&]+"));
  return url.replace(regExPattern, "$1".concat(newValue));
}
function buildProductLinkData(product) {
  var bi = product.bi,
      _product$affiliateLin = product.affiliateLink,
      affiliateLink = _product$affiliateLin === void 0 ? '' : _product$affiliateLin,
      phoneNumberAttribute = product.phoneNumberAttribute;

  var _ref2 = bi !== null && bi !== void 0 ? bi : {},
      blrs = _ref2.blrs;

  var _ref3 = phoneNumberAttribute !== null && phoneNumberAttribute !== void 0 ? phoneNumberAttribute : {},
      phoneBlrs = _ref3.blrs,
      phoneNumberValue = _ref3.phoneNumber,
      _ref3$show = _ref3.show,
      show = _ref3$show === void 0 ? false : _ref3$show;

  var productLinkData = {
    url: {
      value: affiliateLink,
      blrs: blrs
    }
  };

  if (phoneBlrs && phoneNumberValue) {
    Object.assign(productLinkData, {
      phone: {
        value: phoneNumberValue,
        blrs: phoneBlrs,
        show: show
      }
    });
  }

  return productLinkData;
}

var QUERY_PARAMS = {
  comp_iid: 'comp_iid'
};
var PRODUCTS_ATTRIBUTES = ['productListHeader', 'data'];
var BASE_REPORT_ATTRIBUTES = ['comp_iid', 'componentHeader'];

function getComponentReportAttributes(_ref) {
  var _ref$hasProducts = _ref.hasProducts,
      hasProducts = _ref$hasProducts === void 0 ? false : _ref$hasProducts;
  var attributes = BASE_REPORT_ATTRIBUTES;

  if (hasProducts) {
    attributes = [].concat(_toConsumableArray(attributes), PRODUCTS_ATTRIBUTES);
  }

  return attributes;
}

function buildComponentReportData(options) {
  var comp_name = options.comp_name,
      entity = options.entity,
      productList = options.productList,
      _options$useProductCu = options.useProductCustomFeatures,
      useProductCustomFeatures = _options$useProductCu === void 0 ? false : _options$useProductCu,
      _options$reportProduc = options.reportProductFeatures,
      reportProductFeatures = _options$reportProduc === void 0 ? false : _options$reportProduc,
      _options$updateAffili = options.updateAffiliateLinkCompIID,
      updateAffiliateLinkCompIID = _options$updateAffili === void 0 ? false : _options$updateAffili;
  var comp_iid = uuid.v4();
  var reportData = {};
  var productsWithUpdatedAffiliateLinks = [];
  reportData.componentHeader = {
    type: entity.entityType,
    comp_id: entity.id,
    comp_name: comp_name,
    comp_iid: comp_iid
  };

  if (productList !== null && productList !== void 0 && productList.products) {
    reportData.productListHeader = {
      product_list_id: productList.id,
      product_list_var_id: productList.varId,
      product_list_var_version: productList.ver
    };
    reportData.data = {
      products: productList.products.map(function (product) {
        var id = product.id,
            varId = product.varId,
            ver = product.ver,
            entityType = product.entityType,
            position = product.position,
            legacyId = product.legacyId,
            displayName = product.displayName,
            productType = product.productType,
            affiliateLink = product.affiliateLink,
            affiliateLinkDetails = product.affiliateLinkDetails,
            _product$featuresToRe = product.featuresToReport,
            featuresToReport = _product$featuresToRe === void 0 ? [] : _product$featuresToRe;

        if (updateAffiliateLinkCompIID && affiliateLink) {
          var updatedLink = addOrReplaceParameterValueInUrl({
            url: affiliateLink,
            parameterName: QUERY_PARAMS.comp_iid,
            newValue: comp_iid
          });

          var updatedAffiliateLinkDetails = _objectSpread2(_objectSpread2({}, affiliateLinkDetails), {}, {
            url: updatedLink,
            comp_iid: comp_iid
          });

          productsWithUpdatedAffiliateLinks.push(_objectSpread2(_objectSpread2({}, product), {}, {
            affiliateLink: updatedLink,
            affiliateLinkDetails: updatedAffiliateLinkDetails
          }));
        }

        return {
          id: id,
          product_id: legacyId,
          display_name: displayName,
          varId: varId,
          ver: ver,
          entityType: entityType,
          position: position,
          productType: productType,
          product_link: buildProductLinkData(product),
          features: [].concat(_toConsumableArray(extractProductFeaturesFromProduct({
            productFeatures: entity.productFeatures,
            product: product
          })), _toConsumableArray(useProductCustomFeatures && get__default$1["default"](product, 'customFeatures') || []), _toConsumableArray(reportProductFeatures ? featuresToReport : []))
        };
      })
    };
  }

  return _objectSpread2({
    comp_iid: comp_iid,
    reportData: reportData,
    attrs: getComponentReportAttributes({
      hasProducts: Boolean(productList === null || productList === void 0 ? void 0 : productList.products)
    })
  }, updateAffiliateLinkCompIID && {
    productsWithUpdatedAffiliateLinks: productsWithUpdatedAffiliateLinks
  });
}

function buildReportCrossChart(reportData) {
  var _chart$productList$pr, _chart$productList, _chart$productList$pr2;

  var _reportData$common = reportData.common,
      common = _reportData$common === void 0 ? {} : _reportData$common,
      _reportData$maxItems = reportData.maxItems,
      maxItems = _reportData$maxItems === void 0 ? 999 : _reportData$maxItems,
      _reportData$products = reportData.products,
      products = _reportData$products === void 0 ? [] : _reportData$products,
      widgetId = reportData.widgetId,
      _reportData$chart = reportData.chart,
      chart = _reportData$chart === void 0 ? {} : _reportData$chart,
      manipulators = reportData.manipulators,
      textOnCTA = reportData.textOnCTA;
  var reportCrossChart = buildReportChart({
    manipulators: manipulators,
    textOnCTA: textOnCTA,
    siteId: common.siteId,
    products: products.slice(0, maxItems),
    chart: _objectSpread2(_objectSpread2({}, chart), {}, {
      productList: _objectSpread2(_objectSpread2({}, chart.productList), {}, {
        products: (_chart$productList$pr = chart === null || chart === void 0 ? void 0 : (_chart$productList = chart.productList) === null || _chart$productList === void 0 ? void 0 : (_chart$productList$pr2 = _chart$productList.products) === null || _chart$productList$pr2 === void 0 ? void 0 : _chart$productList$pr2.slice(0, maxItems)) !== null && _chart$productList$pr !== void 0 ? _chart$productList$pr : []
      })
    })
  });
  var context = lodash.pick(common, ['siteId', 'vertical', 'segment']);
  reportCrossChart.reportProps = _objectSpread2(_objectSpread2({}, reportCrossChart.reportProps), {}, {
    context: context,
    widgetId: widgetId
  });
  return reportCrossChart;
}

var ReportCollectorContext = /*#__PURE__*/React.createContext({
  report: null
});
var useReportContext = function useReportContext() {
  return React.useContext(ReportCollectorContext);
};

function ReportsCollector(_ref) {
  var reportContext = _ref.reportContext,
      report = _ref.report,
      children = _ref.children;
  var parentReport = report(reportContext);
  var contextValue = {
    report: function report(context, data, info) {
      var childReport = {
        reportContext: context,
        entity: data,
        component: info,
        children: []
      };
      parentReport.children.push(childReport);
      return childReport;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(ReportCollectorContext.Provider, {
    value: contextValue
  }, children);
}

var ReportContext = /*#__PURE__*/React__default["default"].createContext({
  report: null
});
var PROPS_TO_REPORT = ['id', 'varId', 'ver', 'entityType', 'manipulators'];

var renderWithInfo = function renderWithInfo(_ref, child) {
  var name = _ref.name,
      version = _ref.version,
      type = _ref.type;
  return /*#__PURE__*/React__default["default"].cloneElement(child, {
    'data-name': name,
    'data-version': version,
    'data-type': type
  });
};

function Report(_ref2) {
  var reportContext = _ref2.reportContext,
      _ref2$attrs = _ref2.attrs,
      attrs = _ref2$attrs === void 0 ? [] : _ref2$attrs,
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? null : _ref2$data,
      info = _ref2.info,
      children = _ref2.children;
  var parentContext = useReportContext();
  var report = parentContext.report;
  var parentReport;
  var dataToReport;

  if (report) {
    dataToReport = pick__default$1["default"](data, [].concat(PROPS_TO_REPORT, _toConsumableArray(attrs)));
    parentReport = report(reportContext, dataToReport, info);
  }

  var contextValue = {
    report: function report(context, data, info) {
      var childReport = {
        reportContext: context,
        entity: data,
        component: info,
        children: []
      };
      parentReport.children.push(childReport);
      return childReport;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(ReportContext.Provider, {
    value: contextValue
  }, info ? renderWithInfo(info, children) : children);
}

var addCompIIDToProductLinks = function addCompIIDToProductLinks() {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var compIID = arguments.length > 1 ? arguments[1] : undefined;
  var extraAffiliateLinkKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return products.map(function (product) {
    var affiliateLink = addOrReplaceParameterValueInUrl({
      url: product.affiliateLink,
      parameterName: 'comp_iid',
      newValue: compIID
    });
    var extraAffiliateLink;

    if (product[extraAffiliateLinkKey]) {
      extraAffiliateLink = addOrReplaceParameterValueInUrl({
        url: product[extraAffiliateLinkKey],
        parameterName: 'comp_iid',
        newValue: compIID
      });
    }

    return _objectSpread2(_objectSpread2({}, product), {}, _defineProperty$1({
      affiliateLink: affiliateLink
    }, extraAffiliateLinkKey, extraAffiliateLink));
  });
};

var ComponentReport = function ComponentReport(_ref) {
  var entity = _ref.entity,
      products = _ref.products,
      compName = _ref.compName,
      _ref$extraAffiliateLi = _ref.extraAffiliateLinkKey,
      extraAffiliateLinkKey = _ref$extraAffiliateLi === void 0 ? '' : _ref$extraAffiliateLi,
      reportProductFeatures = _ref.reportProductFeatures,
      children = _ref.children;

  if (!children) {
    return null;
  }

  var productList = entity.productList;

  var _buildComponentReport = buildComponentReportData({
    entity: entity,
    productList: _objectSpread2(_objectSpread2({}, productList), {}, {
      products: products
    }),
    comp_name: compName,
    updateAffiliateLinkCompIID: true,
    reportProductFeatures: reportProductFeatures
  }),
      compIID = _buildComponentReport.comp_iid,
      _buildComponentReport2 = _buildComponentReport.reportData,
      reportData = _buildComponentReport2 === void 0 ? {} : _buildComponentReport2,
      _buildComponentReport3 = _buildComponentReport.attrs,
      attrs = _buildComponentReport3 === void 0 ? [] : _buildComponentReport3;

  var productsWithCompIID = addCompIIDToProductLinks(products, compIID, extraAffiliateLinkKey);
  return /*#__PURE__*/React__default["default"].createElement(Report, {
    "data-testid": "component-report",
    reportContext: niConstants.constantsComponents.reportContext.COMPONENT,
    data: reportData,
    attrs: attrs
  }, children({
    products: productsWithCompIID
  }));
};

exports.ReportContextOptions = void 0;

(function (ReportContextOptions) {
  ReportContextOptions["PAGE_CHART"] = "page-chart";
  ReportContextOptions["PAGE_REVIEW"] = "page-review";
  ReportContextOptions["PAGE_ARTICLE"] = "page-article";
  ReportContextOptions["PAGE_AGG_ARTICLES"] = "page-agg-articles";
  ReportContextOptions["PAGE_AGG_REVIEWS"] = "page-agg-reviews";
  ReportContextOptions["PAGE_STATIC"] = "page-static";
  ReportContextOptions["CROSS_CHART"] = "cross-chart";
  ReportContextOptions["COMPONENT"] = "Component";
  ReportContextOptions["STICKY_PRODUCT"] = "sticky-tiki";
  ReportContextOptions["SIDE_BANNER"] = "side-banner";
})(exports.ReportContextOptions || (exports.ReportContextOptions = {}));

exports.ComponentReport = ComponentReport;
exports.Report = Report;
exports.ReportsCollector = ReportsCollector;
exports.addCompIIDToProductLinks = addCompIIDToProductLinks;
exports.addOrReplaceParameterValueInUrl = addOrReplaceParameterValueInUrl;
exports.buildComponentReportData = buildComponentReportData;
exports.buildReportChart = buildReportChart;
exports.buildReportCrossChart = buildReportCrossChart;
exports.useReportContext = useReportContext;
